import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;
